module.exports = __webpack_public_path__ + "static/media/icon-compartilhados.680bb0ec.svg";